import { render, staticRenderFns } from "./CustomerTradingSettings.vue?vue&type=template&id=e70b1942&"
import script from "./CustomerTradingSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerTradingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports